/* eslint-disable no-use-before-define,jsx-a11y/iframe-has-title */
import React from 'react'

export const FrameIn = ({src, height=200, dataName='twd-frame', frameName, getHeight} = {}) => {
    const [loading, setLoading] = React.useState(false)

    React.useEffect(() => {
        setLoading(true)
    }, [src])

    return <React.Fragment>
    { loading && (
        <div style={{minWidth:'150px'}}>
        <div data-name="loading-spinner" className="spinner" style={{ width:"45px" }}>
        <svg className="circular" viewBox="25 25 50 50">
            <circle className="background" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
            <circle className="path" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
        </svg>
        </div>
        </div>
    )}

    <iframe
    data-name={dataName}
    src={src}

    style={{
        width:'100%',
        minHeight: '250px',
        visibility:'hidden'
    }}
    marginWidth="0"
    marginHeight="0"
    frameBorder="0"
    onLoad={(ev) => {
        ev.persist()
        let e = ev.target
        e.style.visibility = 'visible'

        let fn = () => {
            try {
                let w = e.contentWindow
                let d = w.document
                let b = d.body
                let de = d.documentElement

                var frameHeight = 0
                if (frameName)
                try {
                    let fr = w.frames[frameName]
                    let fd = fr.document
                    let fb = fd.body
                    let fde = fd.documentElement
                    frameHeight = Math.max( fb.scrollHeight, fb.offsetHeight,
                        fde.clientHeight, fde.scrollHeight, fde.offsetHeight)
                } catch(e) {
                }

                var calcHeight = 0
                if (getHeight)
                try {
                    calcHeight = getHeight(w)
                } catch(e) {
                }

                let h = calcHeight || Math.max(
                    b.scrollHeight, b.offsetHeight,
                    de.clientHeight, de.scrollHeight, de.offsetHeight,
                    frameHeight)
                if (parseInt(h, 10)) {
                    e.style.height = Math.max(h, height) + 'px'
                }
            } catch(x) {
                clearInterval(resizeInt)
                e.style.height = '100%'
            }
        }

        let resizeInt = setInterval(() => { fn() }, 1000)
        fn()

        setLoading(false)
    }}
    ></iframe>
    </React.Fragment>
}